const DATA_ATTRIBUTE_ONLY_TRACK_IF = 'data-ft5-only-track-if';

export class TrackingHtmlConditionChecker {
    public isConditionMet(target: Element): boolean {
        const conditionString = target.getAttribute(DATA_ATTRIBUTE_ONLY_TRACK_IF);
        if (!conditionString) {
            return true;
        }

        if (conditionString.includes('BREAKPOINT')) {
            return TrackingHtmlConditionChecker.evaluateBreakpointCondition(conditionString);
        }

        return false;
    }

    private static evaluateBreakpointCondition(conditionData: string) {
        const splitBreakpoints = conditionData.toLowerCase().split('_');
        const currentBreakpoint = o_global.breakpoint.getCurrentBreakpoint().toLowerCase();
        return splitBreakpoints.includes(currentBreakpoint);
    }
}
